import type { Comic } from "@/types/comic";

export const comics: Comic[] = [
  {
    id: "night-garden",
    title: "夜色花园的她们",
    cover: "https://readdy.ai/api/search-image?query=Soft%20romantic%20manhwa%20cover%20illustration%20of%20two%20young%20women%20standing%20close%20in%20a%20moonlit%20night%20garden%20surrounded%20by%20glowing%20white%20flowers%2C%20gentle%20pastel%20sky%20blue%20and%20warm%20amber%20lighting%2C%20delicate%20line%20art%2C%20dreamy%20watercolor%20texture%2C%20clean%20minimal%20background%2C%20elegant%20korean%20webtoon%20style&width=400&height=600&seq=comic-night-garden&orientation=portrait",
    author: "尹夏琳",
    status: "连载中",
    genres: ["校园", "恋爱", "治愈"],
    tags: ["甜宠", "暗恋", "双向奔赴"],
    updatedAt: "2026-10-13",
    latestChapter: "第 46 话 · 花园里的告白",
    views: 1523000,
    likes: 98200,
    rating: 9.6,
    intro: "转学生韩诗雅在深夜的校园后花园，遇见了独自照料白花的学姐尹夏琳。一个习惯把心事藏进画里，一个总在夜色中守着一片不会有人来的花园。当两人的秘密在月光下重叠，一段温柔而克制的双女主恋曲悄然绽放。作品以细腻的心理描写与治愈系画风，讲述两个女孩如何在彼此的世界里找到被接纳的勇气。",
    chapters: [
      { id: "c1", title: "第 1 话 · 深夜的转学生", date: "2026-06-02" },
      { id: "c2", title: "第 5 话 · 白花与画本", date: "2026-06-20" },
      { id: "c3", title: "第 12 话 · 雨夜的伞", date: "2026-07-11" },
      { id: "c4", title: "第 20 话 · 心跳的距离", date: "2026-08-03" },
      { id: "c5", title: "第 28 话 · 被看见的心事", date: "2026-08-25" },
      { id: "c6", title: "第 36 话 · 花园的秘密", date: "2026-09-16" },
      { id: "c7", title: "第 42 话 · 月下的约定", date: "2026-10-01" },
      { id: "c8", title: "第 46 话 · 花园里的告白", date: "2026-10-13" },
    ],
  },
  {
    id: "duchess-contract",
    title: "契约女公爵",
    cover: "https://readdy.ai/api/search-image?query=Grand%20fantasy%20manhwa%20cover%20with%20two%20noble%20women%20in%20elegant%20robes%20standing%20in%20a%20marble%20ballroom%2C%20one%20in%20soft%20blue%20gown%20one%20in%20warm%20amber%20dress%2C%20golden%20chandelier%20light%2C%20ornate%20architecture%2C%20refined%20detailed%20line%2C%20romantic%20webtoon%20illustration%20style%2C%20consistent%20clean%20background&width=400&height=600&seq=comic-duchess-contract&orientation=portrait",
    author: "PARK YURA",
    status: "连载中",
    genres: ["奇幻", "恋爱", "古风"],
    tags: ["契约", "强强", "甜宠"],
    updatedAt: "2026-10-12",
    latestChapter: "第 58 话 · 假戏真做的舞会",
    views: 2134000,
    likes: 145600,
    rating: 9.8,
    intro: "为了守住家族领地，落魄千金艾黛尔不得不与冷面女公爵薇拉签订一纸婚约。本该只是各取所需的交易，却在一次次并肩应对贵族阴谋中，生出无法否认的情愫。华丽宫廷背景下的强强对决，两位女性如何以智慧与真心改写彼此命运的走向。",
    chapters: [
      { id: "c1", title: "第 1 话 · 一纸婚约", date: "2026-05-10" },
      { id: "c2", title: "第 8 话 · 领地危机", date: "2026-06-05" },
      { id: "c3", title: "第 18 话 · 贵族舞会", date: "2026-07-02" },
      { id: "c4", title: "第 30 话 · 面具之下", date: "2026-08-08" },
      { id: "c5", title: "第 40 话 · 深夜长廊", date: "2026-09-01" },
      { id: "c6", title: "第 50 话 · 无法说出口", date: "2026-09-26" },
      { id: "c7", title: "第 58 话 · 假戏真做的舞会", date: "2026-10-12" },
    ],
  },
  {
    id: "her-warmth",
    title: "她的温度",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20urban%20manhwa%20cover%20of%20two%20women%20sharing%20a%20warm%20blanket%20on%20a%20rainy%20city%20apartment%20evening%2C%20soft%20sky%20blue%20window%20light%20with%20amber%20lamps%2C%20intimate%20gentle%20expressions%2C%20pastel%20palette%2C%20clean%20line%20art%2C%20korean%20webtoon%20illustration%20style&width=400&height=600&seq=comic-her-warmth&orientation=portrait",
    author: "李书妍",
    status: "完结",
    genres: ["都市", "治愈", "日常"],
    tags: ["治愈系", "慢热", "双向奔赴"],
    updatedAt: "2026-10-09",
    latestChapter: "完结篇 · 往后的每一个冬天",
    views: 986000,
    likes: 76300,
    rating: 9.4,
    intro: "加班到深夜的插画师与独居的咖啡师成了对门邻居。从借用一杯热水开始，两段疲惫的都市人生慢慢靠近。没有惊天动地的剧情，只有雨天、热汤和一句“我等你回家”的平淡温柔。全篇完结，是许多读者心中的治愈系白月光。",
    chapters: [
      { id: "c1", title: "第 1 话 · 对门的新邻居", date: "2026-03-01" },
      { id: "c2", title: "第 9 话 · 一杯热水", date: "2026-03-28" },
      { id: "c3", title: "第 20 话 · 雨夜的沙发", date: "2026-05-14" },
      { id: "c4", title: "第 32 话 · 一起的早餐", date: "2026-07-06" },
      { id: "c5", title: "第 41 话 · 说不出口的话", date: "2026-08-20" },
      { id: "c6", title: "完结篇 · 往后的每一个冬天", date: "2026-10-09" },
    ],
  },
  {
    id: "under-the-stars",
    title: "星辰之下共眠",
    cover: "https://readdy.ai/api/search-image?query=Ethereal%20fantasy%20manhwa%20cover%20of%20two%20women%20adventurers%20lying%20on%20a%20hill%20under%20a%20starry%20night%20sky%2C%20glowing%20constellations%2C%20one%20with%20silver%20hair%20and%20blue%20cloak%20one%20with%20amber%20hair%2C%20magical%20soft%20glow%2C%20detailed%20webtoon%20line%20art%2C%20dreamy%20harmonious%20palette&width=400&height=600&seq=comic-under-stars&orientation=portrait",
    author: "JEON HANA",
    status: "连载中",
    genres: ["奇幻", "科幻", "恋爱"],
    tags: ["双向奔赴", "冒险", "治愈系"],
    updatedAt: "2026-10-11",
    latestChapter: "第 39 话 · 星轨尽头",
    views: 1245000,
    likes: 88900,
    rating: 9.5,
    intro: "在一场会吞噬星光的灾厄中，星象学者莉安与流浪剑姬诺雅被迫结伴踏上旅途。她们一个能读懂星空，一个能斩开黑暗，而彼此成了对方唯一的坐标。宏大的世界观与细腻的情感线交织，讲述一段跨越星海的宿命相遇。",
    chapters: [
      { id: "c1", title: "第 1 话 · 坠落的星", date: "2026-05-20" },
      { id: "c2", title: "第 7 话 · 结伴同行", date: "2026-06-18" },
      { id: "c3", title: "第 15 话 · 剑与星图", date: "2026-07-22" },
      { id: "c4", title: "第 24 话 · 荒原之夜", date: "2026-08-19" },
      { id: "c5", title: "第 32 话 · 共同的誓言", date: "2026-09-20" },
      { id: "c6", title: "第 39 话 · 星轨尽头", date: "2026-10-11" },
    ],
  },
  {
    id: "dessert-rumor",
    title: "甜品店的绯闻",
    cover: "https://readdy.ai/api/search-image?query=Cheerful%20romance%20manhwa%20cover%20of%20two%20young%20women%20bakers%20in%20a%20bright%20pastel%20dessert%20shop%2C%20cakes%20and%20macarons%2C%20sky%20blue%20and%20warm%20orange%20accents%2C%20playful%20happy%20expressions%2C%20clean%20line%20art%2C%20cozy%20webtoon%20illustration%20style&width=400&height=600&seq=comic-dessert-rumor&orientation=portrait",
    author: "金多恩",
    status: "连载中",
    genres: ["都市", "美食", "恋爱"],
    tags: ["欢喜冤家", "甜宠", "日常"],
    updatedAt: "2026-10-10",
    latestChapter: "第 33 话 · 第二份配方",
    views: 763000,
    likes: 54100,
    rating: 9.2,
    intro: "甜点师秀妍的隔壁，开了一家总抢她生意的网红甜品店，而店主竟是大学时和她针锋相对的学妹。两个嘴硬的女孩从互相较劲到深夜共研配方，甜味在烤箱的灯光里慢慢发酵。轻松搞笑又治愈的美食恋爱物语。",
    chapters: [
      { id: "c1", title: "第 1 话 · 抢生意的邻居", date: "2026-06-08" },
      { id: "c2", title: "第 6 话 · 招牌之争", date: "2026-07-01" },
      { id: "c3", title: "第 14 话 · 深夜的烤箱", date: "2026-08-04" },
      { id: "c4", title: "第 22 话 · 打烊后的蛋糕", date: "2026-09-02" },
      { id: "c5", title: "第 33 话 · 第二份配方", date: "2026-10-10" },
    ],
  },
  {
    id: "sword-and-rose",
    title: "剑与玫瑰之约",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20adventure%20manhwa%20cover%20of%20two%20female%20knights%20back%20to%20back%20holding%20swords%20with%20roses%20blooming%20around%20them%2C%20dramatic%20sky%20blue%20sky%20with%20warm%20sunset%20light%2C%20detailed%20armor%20and%20flowing%20hair%2C%20korean%20webtoon%20action%20illustration%20style&width=400&height=600&seq=comic-sword-rose&orientation=portrait",
    author: "崔智安",
    status: "连载中",
    genres: ["奇幻", "动作", "恋爱"],
    tags: ["强强", "双向奔赴", "热血"],
    updatedAt: "2026-10-08",
    latestChapter: "第 51 话 · 背靠背的誓言",
    views: 1876000,
    likes: 132400,
    rating: 9.7,
    intro: "王国最年轻的两位女骑士，本应是争夺首席之位的宿敌，却在一次次并肩作战中成了彼此最信任的后背。当王城阴谋逼近，她们必须决定：是继续争夺，还是并肩守住共同的荣誉。热血与心动并存的骑士物语。",
    chapters: [
      { id: "c1", title: "第 1 话 · 宿敌骑士", date: "2026-04-12" },
      { id: "c2", title: "第 9 话 · 并肩作战", date: "2026-05-19" },
      { id: "c3", title: "第 19 话 · 王城的阴谋", date: "2026-06-23" },
      { id: "c4", title: "第 30 话 · 玫瑰与伤疤", date: "2026-07-28" },
      { id: "c5", title: "第 41 话 · 首席之争", date: "2026-09-03" },
      { id: "c6", title: "第 51 话 · 背靠背的誓言", date: "2026-10-08" },
    ],
  },
  {
    id: "frost-throne",
    title: "冰封王座的女王",
    cover: "https://readdy.ai/api/search-image?query=Regal%20fantasy%20manhwa%20cover%20of%20an%20ice%20queen%20and%20her%20loyal%20female%20guardian%20in%20a%20frozen%20throne%20hall%2C%20cold%20sky%20blue%20tones%20with%20a%20single%20warm%20amber%20flame%2C%20snow%20falling%2C%20intricate%20royal%20costumes%2C%20refined%20webtoon%20illustration&width=400&height=600&seq=comic-frost-throne&orientation=portrait",
    author: "SHIN EUN",
    status: "连载中",
    genres: ["奇幻", "悬疑", "古风"],
    tags: ["权谋", "虐心", "强强"],
    updatedAt: "2026-10-07",
    latestChapter: "第 44 话 · 未说出口的忠诚",
    views: 1420000,
    likes: 99400,
    rating: 9.5,
    intro: "被诅咒的冰雪女王必须克制一切情感，否则整个王国将陷入永冬。而唯一能让她心跳的人，是贴身守护她多年的女侍卫长。在权谋与诅咒的夹缝里，两人守着一段不敢宣之于口的情意。冷冽唯美的宫廷悬疑剧。",
    chapters: [
      { id: "c1", title: "第 1 话 · 冰封之国", date: "2026-05-01" },
      { id: "c2", title: "第 8 话 · 沉默的侍卫", date: "2026-06-02" },
      { id: "c3", title: "第 17 话 · 一场刺杀", date: "2026-07-04" },
      { id: "c4", title: "第 27 话 · 不能动的心", date: "2026-08-06" },
      { id: "c5", title: "第 44 话 · 未说出口的忠诚", date: "2026-10-07" },
    ],
  },
  {
    id: "cafe-encounter",
    title: "咖啡厅的偶遇",
    cover: "https://readdy.ai/api/search-image?query=Soft%20slice%20of%20life%20manhwa%20cover%20of%20two%20women%20at%20a%20sunny%20cafe%20table%20with%20coffee%20cups%2C%20warm%20morning%20light%20and%20sky%20blue%20accents%2C%20gentle%20smiles%20and%20blushing%20cheeks%2C%20clean%20detailed%20line%20art%2C%20cozy%20korean%20webtoon%20style&width=400&height=600&seq=comic-cafe-encounter&orientation=portrait",
    author: "郑敏儿",
    status: "完结",
    genres: ["都市", "恋爱", "日常"],
    tags: ["甜宠", "慢热", "打工人"],
    updatedAt: "2026-10-05",
    latestChapter: "完结篇 · 第七杯拿铁",
    views: 654000,
    likes: 47200,
    rating: 9.1,
    intro: "每天早晨，她都会在同一个座位点同一杯拿铁，而那个笑容温柔的咖啡师总会在杯子上画一只小猫。从一杯咖啡的默契开始，两个内向的女孩慢慢学会把喜欢说出口。清新可爱的完结短篇。",
    chapters: [
      { id: "c1", title: "第 1 话 · 同一杯拿铁", date: "2026-04-20" },
      { id: "c2", title: "第 6 话 · 杯子上的小猫", date: "2026-05-25" },
      { id: "c3", title: "第 12 话 · 打烊后的告白", date: "2026-07-01" },
      { id: "c4", title: "完结篇 · 第七杯拿铁", date: "2026-10-05" },
    ],
  },
  {
    id: "moon-twins",
    title: "月下双生花",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20historical%20manhwa%20cover%20of%20two%20women%20in%20traditional%20flowing%20hanbok%20dresses%20under%20a%20large%20moon%2C%20plum%20blossoms%20falling%2C%20soft%20blue%20night%20palette%20with%20warm%20lantern%20glow%2C%20poetic%20detailed%20line%20art%2C%20refined%20webtoon%20illustration&width=400&height=600&seq=comic-moon-twins&orientation=portrait",
    author: "韩佳恩",
    status: "连载中",
    genres: ["古风", "恋爱", "悬疑"],
    tags: ["宫廷", "虐心", "破镜重圆"],
    updatedAt: "2026-10-06",
    latestChapter: "第 37 话 · 灯笼下的重逢",
    views: 1090000,
    likes: 81500,
    rating: 9.3,
    intro: "宫里来了两位容貌相似的女子，一个是被选入宫的舞姬，一个是隐姓埋名的贵族遗孤。她们在月下相遇，才知彼此早已被同一段旧事牵连。古风唯美的双生情缘，在花灯与宫墙间缓缓展开。",
    chapters: [
      { id: "c1", title: "第 1 话 · 月下初逢", date: "2026-05-06" },
      { id: "c2", title: "第 10 话 · 相似的面容", date: "2026-06-10" },
      { id: "c3", title: "第 19 话 · 旧事浮现", date: "2026-07-15" },
      { id: "c4", title: "第 28 话 · 宫墙之隔", date: "2026-08-21" },
      { id: "c5", title: "第 37 话 · 灯笼下的重逢", date: "2026-10-06" },
    ],
  },
  {
    id: "memory-fragments",
    title: "记忆碎片中的你",
    cover: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20manhwa%20cover%20of%20two%20women%20facing%20each%20other%20surrounded%20by%20floating%20glowing%20memory%20glass%20shards%2C%20cool%20sky%20blue%20neon%20with%20warm%20amber%20highlights%2C%20emotional%20expressions%2C%20detailed%20webtoon%20digital%20art%20style&width=400&height=600&seq=comic-memory-fragments&orientation=portrait",
    author: "KIM SOA",
    status: "连载中",
    genres: ["科幻", "悬疑", "恋爱"],
    tags: ["虐心", "双向奔赴", "记忆"],
    updatedAt: "2026-10-04",
    latestChapter: "第 41 话 · 被删掉的第七天",
    views: 1330000,
    likes: 94100,
    rating: 9.6,
    intro: "记忆工程师素恩接下一份委托：为一位陌生人找回被抹除的七天记忆。而当碎片一点点拼合，她发现那七天里出现的人，竟是自己。科幻外壳包裹的情感悬疑，追问「如果重来一次，你还会不会选择记得我」。",
    chapters: [
      { id: "c1", title: "第 1 话 · 被抹除的七天", date: "2026-05-15" },
      { id: "c2", title: "第 9 话 · 陌生的熟悉感", date: "2026-06-19" },
      { id: "c3", title: "第 18 话 · 碎片拼图", date: "2026-07-24" },
      { id: "c4", title: "第 29 话 · 第七天之外", date: "2026-08-28" },
      { id: "c5", title: "第 41 话 · 被删掉的第七天", date: "2026-10-04" },
    ],
  },
  {
    id: "stage-twins",
    title: "舞台上的双子星",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20music%20manhwa%20cover%20of%20two%20young%20women%20musicians%20performing%20under%20stage%20spotlights%2C%20one%20with%20guitar%20one%20singing%2C%20sky%20blue%20spotlight%20and%20warm%20orange%20stage%20glow%2C%20energetic%20expressions%2C%20detailed%20webtoon%20illustration&width=400&height=600&seq=comic-stage-twins&orientation=portrait",
    author: "文彩英",
    status: "连载中",
    genres: ["校园", "音乐", "恋爱"],
    tags: ["青春", "双向奔赴", "梦想"],
    updatedAt: "2026-10-03",
    latestChapter: "第 36 话 · 只为你唱的安可",
    views: 872000,
    likes: 61700,
    rating: 9.3,
    intro: "天才作曲系新生与校园乐队主唱因为一次社团招新结下梁子，却不得不在全国大赛上组成双人组合。争吵、排练、深夜的琴房，两个倔强的女孩在音乐里找到了共鸣，也找到了彼此。热血青春的音乐恋爱故事。",
    chapters: [
      { id: "c1", title: "第 1 话 · 社团招新", date: "2026-05-18" },
      { id: "c2", title: "第 8 话 · 被迫组队", date: "2026-06-22" },
      { id: "c3", title: "第 16 话 · 深夜琴房", date: "2026-07-27" },
      { id: "c4", title: "第 25 话 · 全国大赛", date: "2026-09-01" },
      { id: "c5", title: "第 36 话 · 只为你唱的安可", date: "2026-10-03" },
    ],
  },
  {
    id: "otherworld-trap",
    title: "异世界的温柔陷阱",
    cover: "https://readdy.ai/api/search-image?query=Playful%20isekai%20fantasy%20manhwa%20cover%20of%20two%20young%20women%20in%20a%20colorful%20magical%20forest%2C%20one%20holding%20a%20glowing%20potion%20one%20laughing%2C%20sky%20blue%20magic%20sparkles%20and%20warm%20orange%20mushroom%20lights%2C%20bright%20cheerful%20webtoon%20style&width=400&height=600&seq=comic-otherworld-trap&orientation=portrait",
    author: "宋智媛",
    status: "连载中",
    genres: ["奇幻", "恋爱", "治愈"],
    tags: ["喜剧", "欢喜冤家", "异世界"],
    updatedAt: "2026-10-02",
    latestChapter: "第 31 话 · 陷阱里的真心话",
    views: 701000,
    likes: 52300,
    rating: 9.0,
    intro: "穿越到异世界的普通职员被自称「女神」的魔法少女救下，却发现这位女神其实是个闯祸精。一个想回家，一个怕被丢下，两人被迫踏上寻找回家之路的旅程。轻松搞笑又治愈的异世界冒险恋爱喜剧。",
    chapters: [
      { id: "c1", title: "第 1 话 · 穿越的第一天", date: "2026-05-22" },
      { id: "c2", title: "第 7 话 · 闯祸女神", date: "2026-06-26" },
      { id: "c3", title: "第 15 话 · 回家的线索", date: "2026-07-30" },
      { id: "c4", title: "第 24 话 · 并肩的旅程", date: "2026-09-04" },
      { id: "c5", title: "第 31 话 · 陷阱里的真心话", date: "2026-10-02" },
    ],
  },
];